import { OnDestroy, } from '@angular/core';
import { BehaviorSubject, Subject, } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
var JobTriggerBaseComponent = /** @class */ (function () {
    function JobTriggerBaseComponent() {
        this.loading$ = new BehaviorSubject(false);
        this._itemId = 0;
        this._destroyed$ = new Subject();
    }
    Object.defineProperty(JobTriggerBaseComponent.prototype, "itemId", {
        get: function () {
            return this._itemId;
        },
        set: function (value) {
            var _this = this;
            if (this._itemId !== value) {
                this._itemId = value;
                if (this._itemId) {
                    this.loading$.next(true);
                    this._fetchItem()
                        .pipe(takeUntil(this._destroyed$))
                        .subscribe(function (data) {
                        _this.item = data;
                        _this.loading$.next(false);
                    });
                }
                else {
                    this.item = undefined;
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    JobTriggerBaseComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
    };
    return JobTriggerBaseComponent;
}());
export { JobTriggerBaseComponent };
